import { render } from "./HeroiconsOutlineLibrary.vue?vue&type=template&id=02c0a2e9"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineLibrary.vue"]])

export default __exports__